[
  { "code": "AAC", "description": "Army Air Corps or Army Air Force" },
  { "code": "AF ACAD", "description": "Air Force Academy" },
  { "code": "AF", "description": "Air Force" },
  { "code": "AFR", "description": "Air Force Reserves" },
  { "code": "ANG", "description": "Air National Guard" },
  { "code": "AR", "description": "Army Reserves" },
  { "code": "ARMY", "description": "Army" },
  { "code": "ARNG", "description": "Army National Guard" },
  { "code": "CG ACAD", "description": "Coast Guard Academy" },
  { "code": "CG", "description": "Coast Guard" },
  { "code": "CGR", "description": "Coast Guard Reserves" },
  { "code": "MC", "description": "Marine Corps" },
  { "code": "MCR", "description": "Marine Corps Reserves" },
  { "code": "MM", "description": "Merchant Marine" },
  { "code": "N ACAD", "description": "Naval Academy" },
  { "code": "NAVY", "description": "Navy" },
  { "code": "NOAA", "description": "National Oceanic & Atmospheric Administration" },
  { "code": "NR", "description": "Navy Reserves" },
  { "code": "OTH", "description": "Other" },
  { "code": "PHS", "description": "Public Health Service" },
  { "code": "SF", "description": "Space Force" },
  { "code": "USMA", "description": "US Military Academy" },
  { "code": "WAC", "description": "Women's Army Corps" }
]
